/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class TreeService {

        public static relatedClaimLookup: Wars.Domain.Model.Dtos.RelatedClaimDto[];
        private detailedTreeItemNameCache: any;
        private millisecondsToCache: number;
        private slatedForCacheRemoval: any;

        constructor(
            private treeItemService: services.TreeItemService,
            private fieldService: services.FieldService,
            private calculationService: services.CalculationService,
            private conditionService: services.ConditionService,
            private constantService: services.ConstantService,
            private emailGroupService: services.EmailGroupService,
            private formStepService: services.FormStepService,
            private claimDefinitionService: services.ClaimDefinitionService,
            private objectSchemaService: services.ObjectSchemaService,
            private schemaPropertyService: services.SchemaPropertyService,
            private interProcessApiService: services.InterProcessApiService,
            private staticDocumentService: services.ManageStaticDocumentsService,
            private $q: angular.IQService,
            private queryConfigurationService: services.QueryConfigurationService,
            private timeTrackerService: services.TimeTrackerService,
            private systemCodeService: services.SystemCodeService,
            private claimGroupService: services.ClaimGroupService,
            private $timeout: ng.ITimeoutService,
            private $http: ng.IHttpService)
        {
            this.detailedTreeItemNameCache = {};
            this.millisecondsToCache = 5 * 60 * 1000;
            this.slatedForCacheRemoval = {};
        }

        public getTreeConfigurationItem(): models.TreeConfigurationItem {
            return directives.ProcessConfigurationTree.getDecodedTreeItem(false);
        }

        public clearDragValue(): void {
            directives.ProcessConfigurationTree.getDecodedTreeItem(false);
        }

        public createTreeItemFromItemDropped(dataLoadCallback?: () => void): Wars.Domain.Model.TreeItem {
            var treeConfig = this.getTreeConfigurationItem();
            return this.createTreeItemFromConfig(treeConfig, dataLoadCallback);
        }

        public createTreeItemFromConfig(treeConfig: models.TreeConfigurationItem, dataLoadCallback?: () => void): Wars.Domain.Model.TreeItem {
            var dataLoadedFunction = (treeItem: Wars.Domain.Model.TreeItem) => {
                if (treeItem.placeholder === null || treeItem.placeholder === undefined) {
                    treeItem.variableType = this.getTreeItemVariableType(treeItem);
                }
                if (dataLoadCallback) dataLoadCallback();
            }

            var newTreeItem = this.treeItemService.createTreeItem(treeConfig.isSystemLevel);
            newTreeItem.isList = treeConfig.isList !== undefined && treeConfig.isList;
            newTreeItem.isClaimWithValue = treeConfig.isClaimWithValue;
            newTreeItem.itemSource = treeConfig.treeItemSource;
            newTreeItem.variableType = treeConfig.variableType;
            newTreeItem.complexObjectProperty = treeConfig.complexObjectProperty;

            if (treeConfig.staticDocumentId) {
                newTreeItem.staticDocument_id = treeConfig.staticDocumentId;
                this.staticDocumentService.getStaticDocumentById(treeConfig.staticDocumentId).then(
                    (documentMetaData) => {
                        newTreeItem.staticDocument = documentMetaData;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.stepId) {
                newTreeItem.formStep_id = treeConfig.stepId;
                this.formStepService.fetchFormStep(treeConfig.stepId).then(
                    (step) => {
                        newTreeItem.formStep = step;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.claimId) {
                newTreeItem.claim_id = treeConfig.claimId;
                this.claimDefinitionService.getById(treeConfig.claimId).then(
                    (claim) => {
                        newTreeItem.claim = claim;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.processDataId) {
                newTreeItem.schemaProperty_id = treeConfig.processDataId;
                this.schemaPropertyService.getSchemaProperty(treeConfig.processDataId).then(
                    (processDataSchema) => {
                        newTreeItem.schemaProperty = processDataSchema;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.conditionId) {
                newTreeItem.condition_id = treeConfig.conditionId;
                this.conditionService.getCondition(treeConfig.conditionId).then(
                    (condition) => {
                        newTreeItem.condition = condition;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.calculationId) {
                newTreeItem.calculation_id = treeConfig.calculationId;
                this.calculationService.getCalculation(treeConfig.calculationId).then(
                    (calculation) => {
                        newTreeItem.calculation = calculation;

                        var deferred = this.$q.defer();

                        newTreeItem.calculation.entityAspect.loadNavigationProperty("inputSchema").then(() => {
                            newTreeItem.calculation.inputSchema.entityAspect.loadNavigationProperty("properties").then(() => {
                                deferred.resolve();
                            });
                        });

                        this.$q.all([
                            newTreeItem.calculation.entityAspect.loadNavigationProperty("valueOperation"),
                            deferred.promise
                        ]).then(() => {
                            dataLoadedFunction(newTreeItem);
                        });
                    });
            }

            if (treeConfig.constantId) {
                newTreeItem.constantValue_id = treeConfig.constantId;
                this.constantService.getConstant(treeConfig.constantId).then(
                    (constantValue) => {
                        newTreeItem.constantValue = constantValue;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.emailGroupId) {
                newTreeItem.emailGroup_id = treeConfig.emailGroupId;
                this.emailGroupService.getById(treeConfig.emailGroupId).then(
                    (emailGroup) => {
                        newTreeItem.emailGroup = emailGroup;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.queryId) {
                newTreeItem.queryConfiguration_id = treeConfig.queryId;

                this.$q.all([
                    this.queryConfigurationService.getQueryConfiguration(treeConfig.queryId).then(
                        (queryConfiguration) => {
                            newTreeItem.queryConfiguration = queryConfiguration;
                        }),
                    this.queryConfigurationService.getSchemaProperty(treeConfig.schemaPropertyId).then(
                        (schemaProperty) => {
                            newTreeItem.schemaProperty = schemaProperty;
                        })
                ]).then(() => {
                    dataLoadedFunction(newTreeItem);
                });
            }
            else if (treeConfig.relatedClaimProcessTypeId) {
                newTreeItem.relatedClaimProcessType_id = treeConfig.relatedClaimProcessTypeId;
                newTreeItem.claimDefinitionUniqueId = treeConfig.claimUniqueId;
                dataLoadedFunction(newTreeItem);
            }
            else if (treeConfig.interProcessApiId) {
                newTreeItem.interProcessApi_id = treeConfig.interProcessApiId;
                newTreeItem.schemaProperty_id = treeConfig.schemaPropertyId;
                this.$q.all([
                    this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then(
                        (schemaProperty) => {
                            newTreeItem.schemaProperty = schemaProperty;
                        }),
                    this.interProcessApiService.getInterProcessApi(treeConfig.interProcessApiId).then(
                        (interProcessApi) => {
                            newTreeItem.interProcessApi = interProcessApi;
                        })
                ]).then(() => {
                    dataLoadedFunction(newTreeItem);
                });
            }
            else if (treeConfig.schemaPropertyId) {
                newTreeItem.schemaProperty_id = treeConfig.schemaPropertyId;

                this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then(
                    (schemaProperty) => {
                        newTreeItem.schemaProperty = schemaProperty;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.listPropertyId) {
                newTreeItem.schemaProperty_id = treeConfig.listPropertyId;
                newTreeItem.objectSchema_id = treeConfig.listSectionId;

                var schemaPropertyPromise = this.schemaPropertyService.getSchemaProperty(treeConfig.listPropertyId);
                schemaPropertyPromise.then(
                    (schemaProperty) => {
                        newTreeItem.schemaProperty = schemaProperty;
                    });
                var objectSchemaPromise = this.objectSchemaService.getObjectSchema(treeConfig.listSectionId);
                objectSchemaPromise.then(
                    (objectSchema) => {
                        newTreeItem.objectSchema = objectSchema;
                    });

                this.$q.all([schemaPropertyPromise, objectSchemaPromise]).then(() => {
                    dataLoadedFunction(newTreeItem);
                });
            }

            if (treeConfig.placeholder !== undefined) {
                newTreeItem.variableType = treeConfig.variableType;
                newTreeItem.placeholder = treeConfig.placeholder;
                newTreeItem.userClaimDefinition_id = treeConfig.userClaimDefinitionId;

                this.$timeout(() => {
                    dataLoadedFunction(newTreeItem);
                });
            }

            if (treeConfig.timeTrackerId !== undefined) {
                newTreeItem.variableType = treeConfig.variableType;
                newTreeItem.timeTracker_id = treeConfig.timeTrackerId;
                this.timeTrackerService.getTimeTracker(treeConfig.timeTrackerId).then(
                    (timeTracker) => {
                        newTreeItem.timeTracker = timeTracker;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.systemCodeId !== undefined) {
                newTreeItem.variableType = treeConfig.variableType;
                newTreeItem.systemCode_id = treeConfig.systemCodeId;
                this.systemCodeService.getSystemCode(treeConfig.systemCodeId)
                    .then((systemCode) => {
                        newTreeItem.systemCode = systemCode;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            if (treeConfig.claimGroupId !== undefined) {
                newTreeItem.variableType = treeConfig.variableType;
                newTreeItem.claimGroup_id = treeConfig.claimGroupId;
                this.claimGroupService.getGlaimGroup(treeConfig.claimGroupId)
                    .then((claimGroup) => {
                        newTreeItem.claimGroup = claimGroup;
                        dataLoadedFunction(newTreeItem);
                    });
            }

            return newTreeItem;
        }

        public getParentDisplayIcon(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';

            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Calculation) {
                return "glyphicon-superscript";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Claim) {
                return "glyphicon-lock";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.RelatedClaim) {
                return "glyphicon-lock";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Condition) {
                return "glyphicon-copyright-mark";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Constant) {
                return "glyphicon-wrench";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Document) {
                return "glyphicon-file";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.EmailGroup) {
                return "glyphicon-envelope";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField) {
                return "glyphicon-pencil";
            }
            //TODO: add OperationParameter
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Query) {
                return "glyphicon-certificate";
            }
            //TODO: add Step
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable) {
                return "glyphicon-floppy-disk";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.InterProcessApi) {
                return "glyphicon glyphicon-road";
            }

            return null;
        }

        public getParentDisplayName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';

            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Calculation) {
                return "Calculation";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Claim) {
                return "Claim";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.RelatedClaim) {
                return "Related Claim";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Condition) {
                return "Condition";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Constant) {
                return "Constant";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Document) {
                return "Document";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.EmailGroup) {
                return "Email Group";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField) {
                return "Form Field";
            }
            //TODO: add OperationParameter
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Query) {
                return treeItem.queryConfiguration ? treeItem.queryConfiguration.name : "";
            }
            //TODO: add Step
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable) {
                return "Variable";
            }
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.InterProcessApi) {
                return "Inter-Process API";
            }
            if (treeItem.placeholder !== null) {
                return "Placeholder";
            }
            if (treeItem.systemCode_id !== null) {
                return "Code";
            }

            return null;
        }

        public getDetailedDisplayName(treeItem: Wars.Domain.Model.TreeItem): ng.IPromise<string> {
            var defer = this.$q.defer();

            if (treeItem === undefined || treeItem === null) {
                defer.resolve("");
            }
            else if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField ||
                treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable) {

                if (treeItem.schemaProperty_id !== undefined && treeItem.schemaProperty_id !== null) {

                    var cachedValue = this.detailedTreeItemNameCache[treeItem.schemaProperty_id];
                    if (cachedValue !== undefined) {
                        defer.resolve(cachedValue);
                    } else {
                        // Not in cache go get it
                        var handlerUrl = "api/Tree/DetailedTreeItemDisplay/" + treeItem.id;
                        var params = {};
                        this.$http.get(handlerUrl, params).then(
                            (response: any) => {
                                var result = this.handlerResponded(response, params);

                                // Only do the caching thing if not empty
                                if (result !== undefined && result !== null && result !== "") {
                                    this.detailedTreeItemNameCache[treeItem.schemaProperty_id] = result;

                                    // Only slate this for cache removal if not already slated for removal
                                    if (!this.slatedForCacheRemoval.hasOwnProperty(treeItem.schemaProperty_id)) {
                                        this.slatedForCacheRemoval[treeItem.schemaProperty_id] = true;
                                        this.$timeout(() => {
                                                delete this.detailedTreeItemNameCache[treeItem.schemaProperty_id];
                                                delete this.slatedForCacheRemoval[treeItem.schemaProperty_id];
                                            },
                                            this.millisecondsToCache);
                                    }
                                }
                                defer.resolve(result);
                            });
                    }
                } else {
                    defer.resolve("");
                }
            } else {
                var displayName = this.getDisplayName(treeItem);
                defer.resolve(displayName);
            }

            return defer.promise;
        }

        public getDisplayName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (treeItem === undefined || treeItem === null) return "";
            var levelIndicator = treeItem.isSystemLevel ? "System" : "Process";
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField) {
                return this.getDisplayNameBasic(treeItem);
            } else {
                return this.getDisplayNameBasic(treeItem) + '(' + levelIndicator + ')';
            }
        }

        public getDisplayNameBasic(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';

            if (treeItem.interProcessApi) {
                return treeItem.interProcessApi.name + " - " + treeItem.schemaProperty.name;
            }
            if (treeItem.staticDocument) {
                return treeItem.staticDocument.name;
            }
            if (treeItem.formStep) {
                return treeItem.formStep.objectSchema.name;
            }
            if (treeItem.claim) {
                return treeItem.claim.type;
            }
            if (treeItem.claimDefinitionUniqueId) {
                var match = Enumerable.from(TreeService.relatedClaimLookup).firstOrDefault(i => i.uniqueIdentifier === treeItem.claimDefinitionUniqueId);
                return match ? match.claimName : "Could not find in Related Claim Lookup";
            }
            if (treeItem.condition) {
                return treeItem.condition.name;
            }
            if (treeItem.calculation) {
                return treeItem.calculation.name;
            }
            if (treeItem.constantValue) {
                return treeItem.constantValue.name;
            }
            if (treeItem.schemaProperty) {
                if (treeItem.complexObjectProperty != null) {
                    return this.getComplexObjectDisplayName(treeItem.schemaProperty.name, treeItem);
                }
                return treeItem.schemaProperty.name;
            }
            if (treeItem.queryConfiguration) {
                return treeItem.queryConfiguration.name;
            }
            if (treeItem.objectSchema) {
                return treeItem.objectSchema.name;
            }
            if (treeItem.emailGroup) {
                return treeItem.emailGroup.name;
            }
            if (treeItem.timeTracker) {
                return treeItem.timeTracker.name;
            }
            if (treeItem.placeholder !== undefined) {
                switch (treeItem.placeholder) {
                    case Wars.Domain.Model.Codes.Enums.Placeholder.CurrentYear:
                        return "Current Year";
                    case Wars.Domain.Model.Codes.Enums.Placeholder.ProcessIdentifier:
                        return "Process Identifier";
                    case Wars.Domain.Model.Codes.Enums.Placeholder.ProcessType:
                        return "Process Type";
                    case Wars.Domain.Model.Codes.Enums.Placeholder.CurrentDateTime:
                        return this.getComplexObjectDisplayName("Current Date Time", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.CurrentUser:
                        return this.getComplexObjectDisplayName("Current User", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.ProcessInitiator:
                        return this.getComplexObjectDisplayName("Process Initiator", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.NewLine:
                        return "New Line";
                    case Wars.Domain.Model.Codes.Enums.Placeholder.Space:
                        return "Space";
                    case Wars.Domain.Model.Codes.Enums.Placeholder.Tab:
                        return "Tab";
                    case Wars.Domain.Model.Codes.Enums.Placeholder.Empty:
                        return "Empty";
                    case Wars.Domain.Model.Codes.Enums.Placeholder.CurrentStatus:
                        return this.getComplexObjectDisplayName("Current Status", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.CurrentSubType:
                        return this.getComplexObjectDisplayName("Current SubType", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.CurrentState:
                        return this.getComplexObjectDisplayName("Current State", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.UserAction:
                        return this.getComplexObjectDisplayName("Most Recent User Action", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.ProcessEvent:
                        return this.getComplexObjectDisplayName("Current Process Event", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.Assignment:
                        return this.getComplexObjectDisplayName("Current Assignment", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.Review:
                        return this.getComplexObjectDisplayName("Current Review", treeItem);
                    case Wars.Domain.Model.Codes.Enums.Placeholder.AllSelectedDocuments:
                        return "All Selected Documents";
                }
            }

            if (treeItem.systemCode) {
                return this.getComplexObjectDisplayName(treeItem.systemCode.shortDescription, treeItem);
            }
            if (treeItem.claimGroup) {
                return "Claim Group - " + treeItem.claimGroup.name;
            }

            return "getDisplayName() for this tree item type is In-Work";
        }

        private getComplexObjectDisplayName(prefix: string, treeItem: Wars.Domain.Model.TreeItem): string {
            switch (treeItem.complexObjectProperty) {
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Id:
                    return prefix;
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_FirstName:
                    return prefix + ": First Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_MiddleName:
                    return prefix + ": Middle Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_LastName:
                    return prefix + ": Last Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_UserName:
                    return prefix + ": User Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_FullName:
                    return prefix + ": Full Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Email:
                    return prefix + ": User Email";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Company:
                    return prefix + ": User Company";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_PhoneNumber:
                    return prefix + ": Phone Number";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Position:
                    return prefix + ": Position";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_ExternalSystemId:
                    return prefix + ": External System Id";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Claims:
                    return prefix + ": Claims";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_ClaimValues:
                    return prefix + ": Claim Values";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_Id:
                    return prefix;
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_ShortDescription:
                    return prefix + ": Short Description";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_LongDescription:
                    return prefix + ": Long Description";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_EffectiveDate:
                    return prefix + ": Effective Date";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.SubType_Id:
                    return prefix;
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.SubType_DisplayName:
                    return prefix + ": Display Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.SubType_Name:
                    return prefix + ": Name";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_Id:
                    return prefix;
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_ShortDescription:
                    return prefix + ": Short Description";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_LongDescription:
                    return prefix + ": Long Description";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_EffectiveDate:
                    return prefix + ": Effective Date";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_Id:
                    return prefix;
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_ShortDescription:
                    return prefix + ": Short Description";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_LongDescription:
                    return prefix + ": Long Description";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Id:
                    return prefix;
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Code_Id:
                    return prefix + ": Resource Code";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Code_ShortDescription:
                    return prefix + ": Short Description";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Code_LongDescription:
                    return prefix + ": Long Description";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_BeginDate:
                    return prefix + ": Begin Date";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_EndDate:
                    return prefix + ": End Date";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheudledResource_IsBooked:
                    return prefix + ": Is Booked";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_DateTime:
                    return prefix;
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDate:
                    return prefix + ": Short Date";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDate:
                    return prefix + ": Long Date";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDateShortTime:
                    return prefix + ": Short Date/Short Time";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDateLongTime:
                    return prefix + ": Short Date/Long Time";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDateShortTime:
                    return prefix + ": Long Date/Short Time";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDateLongTime:
                    return prefix + ": Long Date/Long Time";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortTime:
                    return prefix + ": Short Time";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongTime:
                    return prefix + ": Long Time";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.UserAction_Comment:
                    return prefix + ": Comment";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.UserAction_Documents:
                    return prefix + ": Documents";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.UserAction_EffectiveDate:
                    return prefix + ": Effective Date";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ProcessEvent_Comment:
                    return prefix + ": Comment";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ProcessEvent_Documents:
                    return prefix + ": Documents";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Id:
                    return prefix + ": Assignment";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Id:
                    return prefix + ": Assignee";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_FirstName:
                    return prefix + ": Assignee First Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_MiddleName:
                    return prefix + ": Assignee Middle Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_LastName:
                    return prefix + ": Assignee Last Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_FullName:
                    return prefix + ": Assignee Full Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Email:
                    return prefix + ": Assignee Email";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Company:
                    return prefix + ": Assignee Company";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_PhoneNumber:
                    return prefix + ": Assignee Phone Number";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Position:
                    return prefix + ": Assignee Position";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Claims:
                    return prefix + ": Assignee Claims";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_ClaimValues:
                    return prefix + ": Assignee Claim Values";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Id:
                    return prefix + ": Assignor";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_FirstName:
                    return prefix + ": Assignor First Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_MiddleName:
                    return prefix + ": Assignor Middle Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_LastName:
                    return prefix + ": Assignor Last Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_FullName:
                    return prefix + ": Assignor Full Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Email:
                    return prefix + ": Assignor Email";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Company:
                    return prefix + ": Assignor Company";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_PhoneNumber:
                    return prefix + ": Assignor Phone Number";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Position:
                    return prefix + ": Assignor Position";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Claims:
                    return prefix + ": Assignor Claims";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_ClaimValues:
                    return prefix + ": Assignor Claim Values";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_AssignedUser_Id:
                    return prefix + ": Assignee";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_FirstName:
                    return prefix + ": Assignee First Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_MiddleName:
                    return prefix + ": Assignee Middle Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_LastName:
                    return prefix + ": Assignee Last Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_FullName:
                    return prefix + ": Assignee Full Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Email:
                    return prefix + ": Assignee Email";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Company:
                    return prefix + ": Assignee Company";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_PhoneNumber:
                    return prefix + ": Assignee Phone Number";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Position:
                    return prefix + ": Assignee Position";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Claims:
                    return prefix + ": Assignee Claims";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_ClaimValues:
                    return prefix + ": Assignee Claim Values";


                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_AssignorUser_Id:
                    return prefix + ": Assignor";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_FirstName:
                    return prefix + ": Assignor First Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_MiddleName:
                    return prefix + ": Assignor Middle Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_LastName:
                    return prefix + ": Assignor Last Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_FullName:
                    return prefix + ": Assignor Full Name";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Email:
                    return prefix + ": Assignor Email";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Company:
                    return prefix + ": Assignor Company";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_PhoneNumber:
                    return prefix + ": Assignor Phone Number";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Position:
                    return prefix + ": Assignor Position";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Claims:
                    return prefix + ": Assignor Claims";
                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_ClaimValues:
                    return prefix + ": Assignor Claim Values";

                case Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Comment:
                    return prefix + ": Comment";
            }
            return "Unknown";
        }

        public getTreeItemVariableType(treeItem: Wars.Domain.Model.TreeItem): Wars.Domain.Model.Codes.Enums.VariableType {
            if (!treeItem) return undefined;

            if (treeItem.complexObjectProperty && treeItem.variableType !== null && treeItem.variableType != undefined) {
                return treeItem.variableType;
            }

            if (treeItem.schemaProperty) {
                return treeItem.schemaProperty.propertyType;
            }
            else if (treeItem.calculation) {
                return treeItem.calculation.valueOperation.variableType;
            }
            else if (treeItem.condition) {
                return Wars.Domain.Model.Codes.Enums.VariableType.Boolean;
            }
            else if (treeItem.constantValue || treeItem.staticDocument || treeItem.emailGroup) {
                return treeItem.constantValue.variableType;
            }
            else if (treeItem.systemCode || treeItem.claim) {
                return treeItem.variableType;
            }
            else if (treeItem.timeTracker) {
                return Wars.Domain.Model.Codes.Enums.VariableType.Integer;
            } else if (treeItem.claimGroup) {
                return Wars.Domain.Model.Codes.Enums.VariableType.ClaimGroup;
            }
            else if (treeItem.relatedClaimProcessType_id) {
                // List of users with the claim
                return Wars.Domain.Model.Codes.Enums.VariableType.List;
            }
            else {
                alert("Still need to implement getTreeItemVariableType for this tree item type");
            }
        }

        public doesTreeItemHaveParameters(treeItem: Wars.Domain.Model.TreeItem): boolean {
            if (treeItem.calculation && treeItem.calculation.inputSchema && treeItem.calculation.inputSchema.properties && treeItem.calculation.inputSchema.properties.length > 0) return true;
            return false;
        }

        public getVariableTypeForField(field: Wars.Domain.Model.Field): angular.IPromise<Wars.Domain.Model.Codes.Enums.VariableType> {
            var d = this.$q.defer();

            switch (field.type) {
                case Wars.Domain.Model.Codes.Enums.FieldType.TextBox:
                case Wars.Domain.Model.Codes.Enums.FieldType.TextArea:
                case Wars.Domain.Model.Codes.Enums.FieldType.PhoneNumber:
                case Wars.Domain.Model.Codes.Enums.FieldType.Zipcode:
                case Wars.Domain.Model.Codes.Enums.FieldType.Url:
                case Wars.Domain.Model.Codes.Enums.FieldType.EmailAddress:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.String);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.RadioButton:
                case Wars.Domain.Model.Codes.Enums.FieldType.Dropdown:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Code);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.CheckBox:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Boolean);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.AutoComplete:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.ProcessId);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Number:
                    d.resolve(field.decimalPlaces && field.decimalPlaces > 0
                        ? Wars.Domain.Model.Codes.Enums.VariableType.Decimal
                        : Wars.Domain.Model.Codes.Enums.VariableType.Integer);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Date:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Date);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Time:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Time);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Currency:
                case Wars.Domain.Model.Codes.Enums.FieldType.Percentage:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Decimal);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.DocumentUpload:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Document);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Label:
                case Wars.Domain.Model.Codes.Enums.FieldType.RichText:
                case Wars.Domain.Model.Codes.Enums.FieldType.CustomButton:
                case Wars.Domain.Model.Codes.Enums.FieldType.CustomDiv:
                case Wars.Domain.Model.Codes.Enums.FieldType.StaticDocument:
                case Wars.Domain.Model.Codes.Enums.FieldType.Payment:
                case Wars.Domain.Model.Codes.Enums.FieldType.CalculationField:
                case Wars.Domain.Model.Codes.Enums.FieldType.StateChange:
                case Wars.Domain.Model.Codes.Enums.FieldType.Map:
                case Wars.Domain.Model.Codes.Enums.FieldType.MapFunction:
                case Wars.Domain.Model.Codes.Enums.FieldType.GisWorkflow:
                case Wars.Domain.Model.Codes.Enums.FieldType.GisQueryGrid:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.None);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.ScheduledResource:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.ScheduledResource);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Status:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Status);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.ProcessActionButton:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.ProcessAction);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.State:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.State);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.MultiSelectStatus:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.MultiSelectStatus);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.MultiSelectState:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.MultiSelectState);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Feature:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Feature);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.ApiGrid:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.ProcessList);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.ProcessType:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.ProcessType);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.SubType:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.SubType);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.UserSelector:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.User);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.ClaimGroup:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.Claim);
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.ReviewGroup:
                    d.resolve(Wars.Domain.Model.Codes.Enums.VariableType.ReviewConfiguration);
                    break;
                default:
                    d.resolve(undefined);
            }
            return d.promise;
        }

        public getRelatedClaimLookup(): ng.IPromise<Wars.Domain.Model.Dtos.RelatedClaimDto[]> {
            var handlerUrl = "api/Tree/RelatedClaims";
            var params = {};
            var result: ng.IPromise<any> = this.$http.post(handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));

            return result;
        }

        private handlerResponded(response: any, params: any): any {
            response.data.requestParams = params;
            return response.data;
        }
    }
}

warsApp.registerService('TreeService', [
    'treeItemService', 'fieldService', 'calculationService', 'conditionService', 'constantService', 'emailGroupService', 'formStepService', 'claimDefinitionService',
    'objectSchemaService', 'schemaPropertyService', "interProcessApiService", 'manageStaticDocumentsService', '$q', 'queryConfigurationService', 'timeTrackerService',
    'systemCodeService', 'claimGroupService', '$timeout', "$http"
]);